import { Box, Typography } from '@mui/material';

export const NotFound = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
    }}
  >
    <Typography variant="textMd" sx={{ color: 'text.secondary' }}>
      404
    </Typography>
  </Box>
);
